<header class="container-fluid pt-3">
    <div class="container">
        <div class="row">
            <div class="col-7 col-md-5">
                <div *ngIf="content.info.generales?.logo_color">
                    <a href="{{  sesion.urlVolver }}" rel="nooppener" target="_self">
                        <img [src]="content.logoURL(content.info.generales?.logo_color)"
                        class="logo" height="auto">
                    </a>
                </div>
            </div>
            <div class="col-5 col-md-7">
                <div class="float-right d-inline-block">
                    <div class="back-cont p-2">
                        <a href="{{  sesion.urlVolver }}" class=" back" rel="nooppener">
                            <i class="arrow left"></i>
                            {{ content.info.login?.txtvolver }}
                        </a>
                    </div>
                </div>    
            </div> 
        </div>
    </div>
</header>